import React from 'react';

const StudentsBillingPage = React.lazy(() => import('./StudentsBillingPage'));

const StudentsBillingConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/students',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentsBillingPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default StudentsBillingConfig;
